module.exports = __webpack_public_path__ + "images/banners/pasodash/macdash_banner_sp_5726c78da07518ea4824227840f03a65.jpg";